export default "\n<ng-container *ngComponentOutlet=\"showInforme\"></ng-container>"